<template>
    <div class="auth auth--password">
        <div class="auth__content col-md-6">
            <div class="auth__content col-lg-6">
                <div class="content__inner">
                    <img alt="logo" class="logo" :src="require('@/assets/img/logo.svg')"/>
                    <amplify-forgot-password
                            username-attributes="email"
                            v-bind:forgotPasswordConfig="forgotPasswordConfig">
                    </amplify-forgot-password>
                </div>
            </div>
        </div>
        <div class="auth__background col-lg-6"
             :style="{backgroundImage:
             'url(' + require(`@/assets/img/auth_background.svg`) + ')' }">
        </div>
    </div>
</template>

<script>
    export default {
        name: "ResetPassword",
        data: () => ({
            forgotPasswordConfig: {}
        }),
    }
</script>

<style scoped>

</style>
